import { parseISODate } from "@/custolink-utils/dates";

export default function transformResponse(data: unknown) {
  if (typeof data !== "object") {
    return data;
  }
  visitObject(
    data as Record<string,unknown>,
    function (key: string, val: unknown, holder: Record<string, unknown>) {
      // this converts iso dates to actual Date objects
      // (see CustomLocalDateSerializer in JacksonConfig.kt)
      const lookFor = "LocalDate#ISO-8601#";
      if (typeof val == "string" && val.startsWith(lookFor)) {
        try {
          holder[key] = parseISODate(val.substring(lookFor.length));
        } catch (err: unknown) {
          console.error("Failed to parse ISO date", err);
        }
      }
    },
  );
  return data;
}

const visitObject = (obj: Record<string, unknown>, fn: (key:string,v:unknown,holder:Record<string,unknown>) => void) =>
  Object.entries(obj).forEach(([k, v]) =>
    typeof v === "object" && v !== null ? visitObject(v as Record<string,unknown>, fn) : fn(k, v, obj),
  );
